var _require = require('crypto'),
    createHash = _require.createHash;

var ecdhComputeSecret = require('./compute_secret');

var concat = function concat(key, length, value) {
  var iterations = Math.ceil(length / 32);
  var res;

  for (var iter = 1; iter <= iterations; iter++) {
    var buf = Buffer.allocUnsafe(4 + key.length + value.length);
    buf.writeUInt32BE(iter, 0);
    key.copy(buf, 4);
    value.copy(buf, 4 + key.length);

    if (!res) {
      res = createHash('sha256').update(buf).digest();
    } else {
      res = Buffer.concat([res, createHash('sha256').update(buf).digest()]);
    }
  }

  return res.slice(0, length);
};

var uint32be = function uint32be(value) {
  var buf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Buffer.allocUnsafe(4);
  buf.writeUInt32BE(value);
  return buf;
};

var lengthAndInput = function lengthAndInput(input) {
  return Buffer.concat([uint32be(input.length), input]);
};

module.exports = function (alg, keyLen, privKey, pubKey) {
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref$apu = _ref.apu,
      apu = _ref$apu === void 0 ? Buffer.alloc(0) : _ref$apu,
      _ref$apv = _ref.apv,
      apv = _ref$apv === void 0 ? Buffer.alloc(0) : _ref$apv;

  var computeSecret = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ecdhComputeSecret;
  var value = Buffer.concat([lengthAndInput(Buffer.from(alg)), lengthAndInput(apu), lengthAndInput(apv), uint32be(keyLen)]);
  var sharedSecret = computeSecret(privKey, pubKey);
  return concat(sharedSecret, keyLen / 8, value);
};